import React from "react";
import App from "../Layouts/AppLayout";
import { Button, Section } from "../Components";

export default function Partnership() {

  return (
    <App>
      <div className="tw-bg-tertiary">
        <Section className="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-4 md:tw-gap-16">
          <div className="tw-flex tw-flex-col tw-justify-between">
            <div>
              <p>The PSP program</p>
              <h1>POD partnership program for sellers</h1>
            </div>

            <div>
              <Button href={'/psp-onboard'} title={'Apply for PSP'} illustrated flat className="tw-hidden md:tw-inline-flex" />
            </div>
          </div>

          <div className="md:tw-col-span-2 tw-space-y-4 md:tw-space-y-8">
            <p>
              Partner with PayOnDelivery (POD) Through Our Exclusive PSP Program <br />
              The PayOnDelivery (POD) Seller Partnership Program (PSP) is an exclusive affiliate opportunity designed for high-performing sellers to share in our success. This invite-only program rewards top sellers with a share of profits based on their sales performance.
            </p>
            <p>As a selected member of the PSP program, you'll not only benefit from your sales but also earn additional rewards by referring other sellers to join PayOnDelivery. Your percentage share grows as you bring more successful sellers into the program, allowing you to maximize your earnings through both performance and networking.</p>

            <Button href={'/psp-onboard'} title={'Apply for PSP'} illustrated flat className="tw-inline-flex md:tw-hidden" />
          </div>
        </Section>
      </div>

      <div className="tw-bg-primary">
        <Section className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4 md:tw-gap-16 tw-text-white">
          <div className="md:tw-col-span-1 tw-flex tw-flex-col tw-justify-between">
            <div className=" tw-space-y-4 md:tw-space-y-8">
              <h2 className="tw-text-white">Referral program</h2>
              <p>At PayOnDelivery (POD), we believe in rewarding our community. Through our referral program, you can earn 3,000 Naira for every 6 people you successfully refer to POD. It’s simple: share your unique referral link with friends, and once they sign up, you start earning.</p>
              <p>As a bonus, anyone who signs up on POD will also receive 500 Naira as a welcome gift. Start sharing your link today and enjoy the rewards!</p>
              <p>Ready to start earning?</p>
            </div>

            <div>
              <Button href={'/psp-onboard'} title={'Get started'} illustrated flat className="tw-hidden md:tw-inline-flex" />
            </div>
          </div>

          <div className="md:tw-col-span-1 tw-space-y-4">
            <img
              src="/assets/images/referral-program-cut.png"
              alt="Referral Program"
              width={732}
              className="tw-h-auto tw-w-[732px] tw-max-w-full"
            />

            <Button href={'/psp-onboard'} title={'Get started'} illustrated flat className="tw-inline-flex md:tw-hidden" />
          </div>
        </Section>
      </div>

      <Section className="tw-grid md:tw-grid-cols-2 tw-gap-4 md:tw-gap-16">
        <div className="tw-flex tw-flex-col tw-justify-between">
          <h2 className="h1">How much can you earn from POD?</h2>

          <div className="tw-flex tw-flex-col md:tw-flex-row tw-justify-between tw-items-center sm:border-on md:border-on tw-rounded-xl tw-py-2 md:tw-py-4 tw-px-2 md:tw-px-6">
            <p className="tw-flex tw-items-center tw-gap-2">
              <img
                src="/assets/images/icons/money-outline.png"
                alt="Referral Program"
                width={56}
                height={56}
                className="tw-h-[56px] tw-w-[56px]"
              />
              PSP Commission
            </p>

            <h1 className="tw-mb-0"><span className="p">up to</span> 6%</h1>
          </div>
        </div>

        <div className="sm:border-on md:border-on tw-rounded-xl tw-py-2 md:tw-py-4 tw-px-2 md:tw-px-6">
          <h5 className="tw-flex tw-items-center tw-gap-2">
            <img
              src="/assets/images/icons/money-outline.png"
              alt="Referral Program"
              width={56}
              height={56}
              className="tw-h-[56px] tw-w-[56px]"
            />
            Signup & referral bonuses
          </h5>

          <div className="tw-flex tw-justify-between tw-items-center">
            <p>Sign up bonus</p>
            <h1 className="tw-mb-0">N500</h1>
          </div>

          <div className="tw-flex tw-justify-between tw-items-center">
            <p>Sign up bonus</p>
            <h1 className="tw-mb-0">N3,000</h1>
          </div>
        </div>
      </Section>

      <div className="tw-bg-tertiary">
        <Section className="tw-flex md:tw-items-center tw-flex-col md:tw-flex-row tw-gap-8 md:tw-gap-16">
          <div className="tw-flex-1">
            <h3 className="h1">Join our affiliate and partnership program.</h3>
            <p>A program to compensate affiliates by providing a chance to earn extra income by referring people to signup.</p>
          </div>
          <Button href={'/psp-onboard'} title={'Get started'} illustrated />
        </Section>
      </div>
    </App>
  );
}
